import { ThemeProvider,Typography } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { useContext,useEffect } from 'react';
import { WebFormContext } from '../../../../context/WebFormContext';
import { SubItemFormFilling } from '../../../../types/new-form-filling/types';
import { getMuiTheme } from '../../../TableHelpers/options';
import CheckIcon from "../../CheckIcon";
import AdditionalInfo from '../../Structure/AdditionalInfo';
import { ptBR } from 'date-fns/locale';

type props = {
  hora: Date | null,
  setHora: Function,
  subitem: SubItemFormFilling,
};


export default function HourComp({
  hora,
  setHora,
  subitem }: props) {
  const { ForceUpdate } = useContext(WebFormContext);

  const textFieldTitle: string = (() => {
    let title = '';
    if (CheckIcon(subitem, hora) === 'naoOk') {
      title += '* ';
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();



  useEffect(() => {
    const dateToEdit = new Date();
    if (subitem.ocorrencia) {
      const [hours, minutes] = (subitem.ocorrencia as string).split(':').map(Number);
      dateToEdit.setHours(hours);
      dateToEdit.setMinutes(minutes);
      setHora(dateToEdit);
    }
    if (subitem.padrao) {
      CheckIcon(subitem, hora);
      const datePadrao = new Date(subitem.padrao as number);
      dateToEdit.setHours(datePadrao.getHours());
      dateToEdit.setMinutes(datePadrao.getMinutes());
      setHora(dateToEdit);
      subitem.ocorrencia = dateToEdit.toTimeString().slice(0, 5);
    }
    if (CheckIcon(subitem, hora) === 'ok') {
      subitem.checked = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subitem.id]);

  useEffect(() => {
    if (hora) {
      subitem.ocorrencia = hora.toTimeString().slice(0, 5);
    }
    if (CheckIcon(subitem, hora) === 'ok') {
      subitem.checked = true;
    } else {
      delete subitem.checked;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hora]);

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      <ThemeProvider theme={getMuiTheme()}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
          <TimePicker
            value={hora}
            sx={{
              height: '100%',
              backfaceVisibility: 'hidden',
              width: '100%'
            }}
            slotProps={{
              textField: {
                required: true,
              },
              actionBar: {
                actions: ['clear', 'accept'],
              },
              field: {
                readOnly: true,
              },
            }}
            localeText={{
              clearButtonLabel: 'Limpar',
            }}
            onChange={(event) => {
              setHora(event);
              if (!event) {
                delete subitem.ocorrencia;
              }
            }}
            className={`${subitem.itemid}|${subitem.id}`}
          />
        </LocalizationProvider>
      </ThemeProvider>
      {hora && <AdditionalInfo subItem={subitem} />}
    </>
  );
}
